<template>
  <div class="heroes">
    <div class="container">
      <ShadowTitle :title="`Эксперты Anti-conference формата`"
                   title-shadow="SPACE HERO"
      />
      <div class="swiper-container swiper-heroes">
        <div :class="windowSize <= 768 ? 'swiper-wrapper' : 'heroes-wrap'">
          <div :class="{'swiper-slide': windowSize <= 768, 'heroes-item': windowSize > 768}"
               v-for="(item, index) in displayedHeroes"
               :key="`hero-${index}`">
            <HeroItem :hero-item="item"/>
          </div>
        </div>
        <div class="swiper-pagination swiper-heroes-pagination"></div>
      </div>
      <button class="global-button _third d-none d-lg-flex align-items-center px-5 mx-auto"
              @click="toggleShowAll()"
      >
        <span class="me-2 px-2">
         {{ showAllHeroes ? 'Скрыть' : 'Показать еще' }}
        </span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1.29289 3.29289C1.68342 2.90237 2.31658 2.90237 2.70711 3.29289L6 6.58579L9.29289 3.29289C9.68342 2.90237 10.3166 2.90237 10.7071 3.29289C11.0976 3.68342 11.0976 4.31658 10.7071 4.70711L6.70711 8.70711C6.31658 9.09763 5.68342 9.09763 5.29289 8.70711L1.29289 4.70711C0.902369 4.31658 0.902369 3.68342 1.29289 3.29289Z"
                fill="white"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import {computed, nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import ShadowTitle from "@/components/ShadowTitle";
import HeroItem from "@/components/main/HeroItem";
import Swiper from "swiper";
import {Pagination} from 'swiper/modules';
import 'swiper/swiper.css';

const heroesData = [
  {
    name: 'Александр<br>Синеркин',
    isHero: true,
    imagePath: require('@/assets/heroes/hero-1.png'),
    videoPath: '',
    position: 'Основатель мебельной <br>фабрики «ФОРТ»',
    list: [
      'Член Общероссийской Общественной организации «Деловая Россия»',
      'Автор книг «Пришествие», «50 кирпичей успеха»',
      'Ментор предпринимателей по масштабированию бизнеса и личности',
    ],
  },
  {
    name: 'Валерия<br>Часовских',
    isHero: true,
    imagePath: require('@/assets/heroes/hero-2.png'),
    videoPath: '',
    position: 'Дипломированный практикующий психолог',
    list: [
      'Создатель авторского курса «Выход из негативной программы»',
      'Основатель женского клуба перезагрузки и продуктивного отдыха для предпринимателей «OutWomansClub»',
    ],
  },
  // {
  //   name: 'Дмитрий<br>Обердерфер ',
  //   isHero: true,
  //   imagePath: require('@/assets/heroes/hero-3.png'),
  //   videoPath: '',
  //   position: 'Экономист-тренер <br>по финансовой грамотности',
  //   list: [
  //     'Экономист-тренер по финансовой грамотности',
  //     'Член Экспертного совета по финансовой грамотности Банка РФ',
  //     'Провел более 1 000 мероприятий в 118 городах России, Беларуси, Казахстана, Германии, Франции, США',
  //     'Обучил более 100 000 граждан',
  //   ],
  // },
  {
    name: 'Игорь <br>Файнман',
    isHero: true,
    imagePath: require('@/assets/heroes/hero-6.png'),
    videoPath: '',
    position: 'Независимый финансовый советник',
    list: [
      'Президент Академии Финансов и Биржи',
      'Сертифицированный лектор Общества «Знание»',
      'Независимый финансовый советник',
      'Создатель TG-канала «Файнманомика»',
      'Финансовый блогер',
    ],
  },
  {
    name: 'Демина <br>Светлана',
    isHero: true,
    imagePath: require('@/assets/heroes/hero-8.png'),
    videoPath: '',
    position: 'Живая легенда -44 кг<br>Тренер для женщин лидеров 30+',
    list: [
      'Мастер спорта международного класса',
      'Создатель первого в России VIP проекта улучшения фигуры для предпринимателей',
      'Член международной ассоциации нутрициологов и коучей России',
      'Фитнес предприниматель. Производитель «Пояса для красивого похудения 30+»',
    ],
  },
  {
    name: 'Алекс <br>Успенская',
    isHero: true,
    imagePath: require('@/assets/heroes/hero-10.png'),
    videoPath: '',
    position: 'Методолог развивающих <br>интервенций ',
    list: [
      'Автор единственной в мире визуализированной системы управления личной ресурсностью через эмоциональный интеллект EMOTIONOMIKS',
      'Режиссер, шоураннер и консультант по личному развитию',
    ],
  },
  {
    name: 'Роман <br>Донской',
    isHero: true,
    imagePath: require('@/assets/heroes/Donskoy.png'),
    videoPath: '',
    position: 'Серийный предприниматель',
    list: [
      'Лидер чаптера бизнес-клуба «Эквиум»',
      'Совладелец сети офисных центров LOCUS и индустриального парка SHAIBA',
      'Мастер х10 academy и курса ДОСТИГАТОР',
    ],
  },
  // {
  //   name: 'Иван <br>Дьяченко',
  //   isHero: true,
  //   imagePath: require('@/assets/heroes/Dyachenko.png'),
  //   videoPath: '',
  //   position: 'Автор книги и бизнес-методологии',
  //   list: [
  //     'Cооснователь сервиса поддержки предпринимателей «Betterthan.today»',
  //     'Автор книги и бизнес-методологии «Бррр-эффект»',
  //     'Тренер и преподаватель креативного системного мышления',
  //   ],
  // },
  {
    name: 'Виктор <br>Гор',
    isHero: true,
    imagePath: require('@/assets/heroes/Gore.png'),
    videoPath: '',
    position: 'Серийный предприниматель',
    list: [
      'Наставник лидеров',
      'Основатель 18 бизнесов, <br>с максимальным оборотом <br>до 2,5 млрд. ₽',
      'Основатель GLAZ и Gagarin group',
      'Открыл 124 ресторана в 12 странах',
    ],
  },
  {
    name: 'Ирина <br>Морева',
    isHero: true,
    imagePath: require('@/assets/heroes/Moreva.png'),
    videoPath: '',
    position: 'Наставник по Личной Эволюции',
    list: [
      'Автор интеграционной системы ДНК Личности',
      'Создатель авторской программы трансформации «Эволюция Личности»',
      'Гипнотерапевт, ченнелер. Мастер потокового состояния и формирования реальности',
      'Человек мира — Казахстан, Россия, Тайланд, Австралия',
    ],
  },
  {
    name: 'Можегова <br>Наталья',
    isHero: true,
    imagePath: require('@/assets/heroes/Mozhegova.png'),
    videoPath: '',
    position: 'Эксперт в теме предназначения души',
    list: [
      'Основатель онлайн школы Душевной нумерологии',
      'Кармический целитель',
      'Работает в теме самопознания, помогает людям стать Автором своей жизни',
      'Автор обучающих курсов в теме Духовного развития и Предназначения',
    ],
  },
  {
    name: 'Екатерина <br>Черных',
    isHero: true,
    imagePath: require('@/assets/heroes/Chernykh.png'),
    videoPath: '',
    position: 'Эксперт по финансовой культуре',
    list: [
      'Автор фестиваля трансформационных финансовых игр «Манифест»',
      'Основатель продюсерского центра BRUNCH, Академии финансовой культуры «ФОРМУЛА ДЕНЕГ»',
      'Автор трех трансформационных бизнес-игр',
    ],
  },

]

export default {
  name: "Heroes",
  components: {HeroItem, ShadowTitle},
  setup() {
    const heroes = ref(heroesData);
    const showAllHeroes = ref(false);
    const swiperInstance = ref(null);
    const windowSize = ref(window.innerWidth);

    const displayedHeroes = computed(() => {
      return windowSize.value <= 768 || showAllHeroes.value ? heroes.value : heroes.value.slice(0, 3);
    });

    const initializeSwiper = () => {
      nextTick(() => {
        if (windowSize.value <= 768) {
          if (!swiperInstance.value) {
            swiperInstance.value = new Swiper('.swiper-heroes', {
              modules: [Pagination],
              pagination: {
                el: '.swiper-heroes-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1.1,
                  spaceBetween: 16
                },
                400: {
                  slidesPerView: 1.5,
                  spaceBetween: 16
                },
                500: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16
                }
              }
            });
          }
        } else if (swiperInstance.value) {
          swiperInstance.value.destroy();
          swiperInstance.value = null;
        }
      });
    }

    const handleResize = () => {
      windowSize.value = window.innerWidth;
    };

    const toggleShowAll = () => {
      showAllHeroes.value = !showAllHeroes.value;
      if (!showAllHeroes.value) {
        nextTick(() => {
          const containerElement = document.querySelector('.heroes');
          if (containerElement) {
            containerElement.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    };

    watch(windowSize, initializeSwiper);

    onMounted(() => {
      initializeSwiper();
      window.addEventListener('resize', handleResize);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      heroes,
      windowSize,
      showAllHeroes,
      displayedHeroes,
      toggleShowAll,
    }
  },
}
</script>

<style lang="scss" scoped>
.heroes-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .heroes-item {
    width: calc((100% - 64px) / 3);
    margin-bottom: 70px;
    margin-right: 32px;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.global-button {
  cursor: pointer;
}
</style>